define('model/unit.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var UnitModel = BaseModel.extend({
    radioRequests: {
      'models UnitModel': '@constructor',
    },

    urlRoot: '/api/v2/unit',
  });
  module.exports = UnitModel;
});

